import React, { FC, useEffect, useCallback, useState } from 'react';
import { Checkbox, Empty, Modal } from 'antd';
import { SpuCombineResult } from '@/interface/label';
import { ItemForVerification, SimilarProduct } from '@/interface/label';
import { useModal } from '@@/react-hooks';
import { ArrayUtils } from '@@/utils';
import { Gallery } from '@/ui/gallery';
import { ItemSelect, SpuSelectableItem, CombineProvider } from '../../item-select';

import commonStyles from '../../../common.module.less';

interface SimilarSpusProps {
  data: ItemForVerification;
  selectedSpuIds: number[];
  onChangeSelectedSpuIds(spuIds: number[]): void;
}

export const SimilarSpus: FC<SimilarSpusProps> = ({ data, selectedSpuIds, onChangeSelectedSpuIds }) => {
  const [zoomModalState, openZoomModal, closeZoomModal] = useModal<SimilarProduct>(null);

  const [similarProducts, setSimilarProducts] = useState([]);

  useEffect(() => {
    setSimilarProducts(
      data.similarProducts.slice(0, 5)
    );
  }, [data]);

  const onCombineFinish = useCallback(
    (combineResult: SpuCombineResult) => {
      const { toDelete, toKeep } = combineResult;
      if (selectedSpuIds.includes(toDelete)) {
        const nextSelectedSpuIds = ArrayUtils.unique(selectedSpuIds.map(id => (id === toDelete ? toKeep : id)));
        onChangeSelectedSpuIds(nextSelectedSpuIds);
      }
      setSimilarProducts(prev => prev.filter(({ id }) => id !== toDelete));
    },
    [onChangeSelectedSpuIds, selectedSpuIds]
  );

  const selectedCount = selectedSpuIds.length;

  if (!similarProducts.length) {
    return (
      <div className={commonStyles.vertical_container}>
        <div className={commonStyles.empty}>
          <Empty description="没有找到相似的商品" />
        </div>
      </div>
    );
  }

  return (
    <div className={commonStyles.vertical_container}>
      <header className={commonStyles.header}>
        <h3 className={commonStyles.title}>请选择可以合并的商品</h3>
        {selectedCount ? <span className={commonStyles.count}>已选中 {selectedCount} 项</span> : null}
      </header>
      <ItemSelect>
        <CombineProvider source="verify-drag" onCombineFinish={onCombineFinish}>
          {similarProducts.map(data => {
            const checked = selectedSpuIds.includes(data.id);
            const onClick = () =>
              onChangeSelectedSpuIds(
                checked ? selectedSpuIds.filter(item => item !== data.id) : [...selectedSpuIds, data.id]
              );
            const onZoom = () => openZoomModal(data);
            return (
              <SpuSelectableItem key={data.id} checked={checked} cols={2} data={data} onClick={onClick} onZoom={onZoom}>
                <Checkbox className={commonStyles.checker} checked={checked} />
              </SpuSelectableItem>
            );
          })}
        </CombineProvider>
      </ItemSelect>
      <Modal
        visible={zoomModalState.visible}
        onCancel={closeZoomModal}
        title={null}
        footer={null}
        width="33vw"
        mask={false}
        maskClosable={false}
        style={{ left: '67vw', margin: 0 }}
      >
        {zoomModalState.data && <Gallery data={zoomModalState.data.images} />}
      </Modal>
    </div>
  );
};
